/**
 * Permalink Handler
 * Handles resolution of permalink shortcuts to full URLs
 */

export class PermalinkManager {
    constructor(links = 'config/permalinks.json') {
        this.links = links;
    }

    /**
     * Check if current URL has a permalink parameter and resolve it
     * @returns {Object|null} Resolved permalink parameters or null
     */
    async detectAndRedirect() {

        const urlParams = new URLSearchParams(window.location.search);
        const permalinkId = urlParams.get('permalink') || urlParams.get('p');
        if (!permalinkId) {
            return;
        }

        const response = await fetch(this.links);
        const data = await response.json();
        if (!(permalinkId in data.permalinks)) {
            return;
        }

        const permalinkUrl = data.permalinks[permalinkId].url;
        const originalHash = window.location.hash;

        // Stash for analytics: an event sent now would be lost in the redirect
        // below, so index.js reports permalink_resolve after the page reloads.
        try { sessionStorage.setItem('amche_permalink_resolved', permalinkId); } catch (e) { /* ignore */ }

        const extraParams = new URLSearchParams(urlParams);
        extraParams.delete('permalink');
        extraParams.delete('p');

        const resolvedUrl = new URL(permalinkUrl);
        for (const [key, value] of extraParams) {
            resolvedUrl.searchParams.set(key, value);
        }

        window.location.replace(`${resolvedUrl.origin}${resolvedUrl.pathname}${resolvedUrl.search}${originalHash}`);
    }
}